import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const PaymentMethodsQuery = gql`
  query ($domain: String!) {
    paymentMethods(where: { eshop: { domain: $domain }}) {
      id
      title
      name
      description
      price
      image
      gateway
      priority
      active
      prices {
        currencyId
        priceWithout
      }
      countries {
        id
        name
      }
    }
    languages {
      id
      value
    }
  }
`;

const CreatePaymentMethodMutation = gql`
  mutation($paymentMethod: CreatePaymentMethodInput!) {
    createPaymentMethod(paymentMethod: $paymentMethod) {
      id
    }
  }
`;

const UpdatePaymentMethodMutation = gql`
  mutation($id: String!, $paymentMethod: UpdatePaymentMethodInput!) {
    updatePaymentMethod(id: $id, paymentMethod: $paymentMethod) {
      id
    }
  }
`;

const DeletePaymentMethodMutation = gql`
  mutation($id: String!) {
    deletePaymentMethod(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
  domain: string;
}

interface Response {
  data: any;
}

class GetPaymentMethodsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const { paymentMethods, createPaymentMethod, updatePaymentMethod, deletePaymentMethod }: any = this.props;
    return this.props.children({
      paymentMethods,
      createPaymentMethod,
      updatePaymentMethod,
      deletePaymentMethod
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(PaymentMethodsQuery, {
    name: 'paymentMethods',
    options: props => ({
      variables: {
        domain: props.domain ? props.domain : '',
      },
    })
  }),
  graphql<IInputProps, Response>(CreatePaymentMethodMutation, {
    name: 'createPaymentMethod'
  }),
  graphql<IInputProps, Response>(UpdatePaymentMethodMutation, {
    name: 'updatePaymentMethod'
  }),
  graphql<IInputProps, Response>(DeletePaymentMethodMutation, {
    name: 'deletePaymentMethod'
  })
)(GetPaymentMethodsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/PaymentMethods/PaymentMethods.tsx